<template>
    <el-dialog fullscreen :visible.sync="show" title="添加/修改" :close-on-press-escape="false">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="优先级">
                <el-radio-group v-model="model.level">
                    <el-radio-button label="1"></el-radio-button>
                    <el-radio-button label="2"></el-radio-button>
                    <el-radio-button label="3"></el-radio-button>
                    <el-radio-button label="4"></el-radio-button>
                    <el-radio-button label="5"></el-radio-button>
                    <el-radio-button label="6"></el-radio-button>
                    <el-radio-button label="7"></el-radio-button>
                    <el-radio-button label="8"></el-radio-button>
                    <el-radio-button label="9"></el-radio-button>
                    <el-radio-button label="10"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="标签">
                <el-autocomplete v-model="model.tag" clearable :fetch-suggestions="querySelectTag"
                    @select="handleSelectTag"></el-autocomplete>
            </el-form-item>
            <el-form-item label="分类">
                <el-autocomplete v-model="model.category" clearable :fetch-suggestions="querySelectCategory"
                    @select="handleSelectCategory"></el-autocomplete>
            </el-form-item>
            <el-form-item label="标题">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="最高预期收益">
                <el-input v-model="model.expectRate"></el-input>
            </el-form-item>
            <el-form-item label="投资期限">
                <el-input v-model="model.timeLimit"></el-input>
            </el-form-item>
            <el-form-item label="起投金额">
                <el-input v-model="model.startAmount"></el-input>
            </el-form-item>
            <el-form-item label="投资领域">
                <el-input v-model="model.field"></el-input>
            </el-form-item>
            <el-form-item label="付息方式">
                <el-input v-model="model.ratio"></el-input>
            </el-form-item>
            <el-form-item label="认购金额">
                <el-input type="textarea" :rows="2" placeholder="5万≤X＜20万   一行一条" v-model="model.amountArea"></el-input>
            </el-form-item>
            <el-form-item label="预计年化">
                <el-input type="textarea" :rows="2" placeholder="12月 8.4%；24月 8.8%    一行一条"
                    v-model="model.rateArea"></el-input>
            </el-form-item>
            <el-form-item label="融资主体">
                <el-input type="textarea" :rows="2" v-model="model.basicInfo"></el-input>
            </el-form-item>
            <el-form-item label="风险措施">
                <el-input type="textarea" :rows="2" v-model="model.riskMeasure"></el-input>
            </el-form-item>
            <el-form-item label="资金用途">
                <el-input type="textarea" :rows="2" v-model="model.moneyPurpose"></el-input>
            </el-form-item>
            <el-form-item label="还款来源">
                <el-input type="textarea" :rows="2" v-model="model.repaySource"></el-input>
            </el-form-item>
            <el-form-item label="区域情况">
                <el-input type="textarea" :rows="2" v-model="model.supplyNote"></el-input>
            </el-form-item>
            <el-form-item label="项目亮点">
                <el-input type="textarea" :rows="2" v-model="model.highlight"></el-input>
            </el-form-item>
            <el-form-item label="募集账号">
                <el-input type="textarea" :rows="2" v-model="model.bankAccount"></el-input>
            </el-form-item>
            <el-form-item label="基础点位">
                <el-input type="number" v-model="model.basePoint"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" :rows="2" v-model="model.remarks"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false" plain>取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { HttpClient } from "../../util/http.js";
import { msgError, msgSuccess } from "../../util/toast";

export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null,
            admins: [],
            type: "",
            date: "",
        };
    },
    computed: {},
    created() { },
    mounted() { },
    methods: {
        handleSelectTag(item) {
            this.model.tag = item.value;
        },
        querySelectTag(queryString, cb) {
            cb([{ value: "精选" }, { value: "售罄" }]);
        },
        handleSelectCategory(item) {
            this.model.category = item.value;
        },
        querySelectCategory(queryString, cb) {
            cb([{ value: "城投债" }, { value: "信托" }]);
        },
        addOrEdit(item) {
            this.show = true;
            this.model = this.deepCopy({
                ...item,
            });
        },
        async save() {
            if (!this.model.category) return msgError("分类 为必填项")
            this.loadingSave = true;
            await HttpClient.put("/restful", {
                model: "Good",
                cond: this.model._id,
                updates: this.model,
            });
            msgSuccess();
            this.show = false;
            this.loadingSave = false;
            this.$emit("fetch-data");
        },
        //深拷贝
        deepCopy(obj) {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                //如果是数组
                const myArray = [];
                for (let i = 0; i < obj.length; i++) {
                    myArray.push(this.deepCopy(obj[i]));
                }
                return myArray;
            } else if (typeof obj == "object") {
                //如果是对象
                const myObject = {};
                for (let key in obj) {
                    myObject[key] = this.deepCopy(obj[key]);
                }
                return myObject;
            }
            return obj;
        },
    },
};
</script>

<style scoped lang="less">
</style>

        